export const environment = {
  production: false,
  PENDO_KEY: '98af3896-b757-41cb-7eeb-6a738e7df7a6',
};
